import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEO from '@/components/feature/SEO';
import SchemaOrg from '@/components/feature/SchemaOrg';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import FeaturedArticles from './components/FeaturedArticles';
import FAQSection from './components/FAQSection';

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' as const });
  }, [location.pathname]);

  return (
    <>
      <SEO
        title="结交善良之人，共建美好人际圈"
        description="人善交，是一种人生智慧：学会辨别善意，主动结交品德高尚的朋友，让你的人际关系更纯粹、更有价值。本网站深度解析人善交的核心理念，助你建立高质量社交圈，远离消耗型关系，收获真诚友谊。"
        keywords="人善交,结交善人,高质量人际关系,交友智慧,良师益友,人脉经营,善意社交"
        canonicalUrl="/"
        ogImage="https://readdy.ai/api/search-image?query=Warm%20sunset%20light%20over%20a%20serene%20landscape%20with%20gentle%20hills%2C%20people%20walking%20together%20on%20a%20winding%20path%2C%20hopeful%20atmosphere%2C%20abstract%20painterly%20style%2C%20warm%20amber%20and%20golden%20tones%2C%20no%20text%2C%20ethereal%20mood&width=2400&height=1260&seq=og-home-2026&orientation=landscape"
      />
      <SchemaOrg type="Organization" />
      <SchemaOrg type="WebSite" />

      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <FeaturedArticles />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}